import { Dimensions, Platform } from "react-native"

export const isMobile = () => {
    return Dimensions.get('window').width < 900 ||
        Platform.OS === 'android' ||
        Platform.OS === 'ios'
}